import { lazy } from "react";

export const HOME_PAGE = lazy(() => import("./Home.jsx"));
export const LOGIN_PAGE = lazy(() => import("./Login.jsx"));
export const DETAIL_PAGE = lazy(() => import("./Detail.jsx"));
export const DASHBOARD_PAGE = lazy(() => import("./Dashboard.jsx"));